import React from 'react';
import SeoMetadata from '../components/Seo/SeoMetadata';
import TituloEscritoriosEscolares from '../components/sections/EscritoriosEscolares/TituloEscritoriosEscolares'; 
import EscritoriosEscolaresIntro from '../components/sections/EscritoriosEscolares/EscritoriosEscolaresIntro'; 
import FormularioContactoEscritorios from '../components/sections/EscritoriosEscolares/FormularioContactoEscritorios'; 
import Header from '../components/layouts/Header';  
import Footer from '../components/layouts/Footer';

const EscritoriosEscolares = () => {
  return (
    <div>
      <SeoMetadata
        title="Escritorios Escolares | Decototal"
        description="Explora escritorios escolares para equipar aulas y espacios de estudio. Solicita información sobre modelos y opciones disponibles."
        keywords="escritorios escolares, mobiliario escolar, escritorios para escuelas, equipamiento para aulas"
        path="/escritorios-escolares"
        image="/assets/img/productos/escritorios-escolares/escritorios-escolares-intro-1.jpg"
      />
      <Header />
        <TituloEscritoriosEscolares />     
        <EscritoriosEscolaresIntro /> 
        <FormularioContactoEscritorios /> 
      <Footer /> 
    </div>
  );
};

export default EscritoriosEscolares;